import * as React from "react";
import { StyleSheet, ImageBackground, Dimensions, View } from "react-native";
import resultBackground from "../../containers/Images/MOBILE_L_standard_wynik.png";
import resolutionMargin, {widthMargin} from "../resolutionMargin";
import MAX_WIDTH from '../MaxWidth';

export default function Background(props) {
  const win = Dimensions.get("window");
  const widthOfBackgroundImage = 1771;
  const heightOfBackgroundImage = 3855;
  const ratio = win.width / widthOfBackgroundImage;

  const styles = StyleSheet.create({
    container: {
      width: "100%",
      maxWidth: props.maxWidth ? props.maxWidth: MAX_WIDTH.SETTINGS,
      alignSelf: 'center',
    },
    screenBackground: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      paddingTop: 0,
    },
  });

  return (
    <ImageBackground
      source={props.noBackground ? null : resultBackground}
      style={{
        ...styles.screenBackground,
        width: resolutionMargin(),
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      <View style={styles.container}>
      {props.children}
      </View>
    </ImageBackground>
  );
}


